import type { PointerEvent, SyntheticEvent } from "react";
import { useEffect, useRef } from "react";

/** How long a chord is held before arranging starts. */
const HOLD_MS = 500;

/** How far a finger may move while holding. Further, and it's scrolling. */
const SLOP_PX = 10;

/**
 * Calls `onHold` when a chord on the sheet is held for half a second, with a finger or the mouse.
 * Spread what it returns on an element around the sheet.
 */
export function useHoldChord(onHold: () => void) {
    const hold = useRef<{ timer: number; x: number; y: number } | undefined>(undefined);

    const stop = () => {
        if (hold.current) clearTimeout(hold.current.timer);

        hold.current = undefined;
    };

    useEffect(() => stop, []);

    return {
        onPointerDown(event: PointerEvent) {
            if (!(event.target as HTMLElement).closest("[data-nth]")) return;

            stop();
            hold.current = { timer: window.setTimeout(onHold, HOLD_MS), x: event.clientX, y: event.clientY };
        },
        onPointerMove(event: PointerEvent) {
            if (hold.current && Math.hypot(event.clientX - hold.current.x, event.clientY - hold.current.y) > SLOP_PX) stop();
        },
        onPointerUp: stop,
        onPointerCancel: stop,
        /** A long press would open the browser's menu over the chord instead. */
        onContextMenu(event: SyntheticEvent) {
            if ((event.target as HTMLElement).closest("[data-nth]")) event.preventDefault();
        },
    };
}
